export default function () {
  const blocks = document.querySelectorAll(".numbers-block");
  if (blocks.length === 0) return;

  const isMobile = window.matchMedia("(max-width: 1023px)").matches;

  if (isMobile) {
    const ctas = document.querySelectorAll(
      ".numbers-block__content-image-and-cta__cta",
    );

    const mobileObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.closest(".numbers-block").classList.add("is-visible");
            mobileObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 },
    );

    ctas.forEach((cta) => mobileObserver.observe(cta));
  } else {
    const desktopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            desktopObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 },
    );

    blocks.forEach((block) => desktopObserver.observe(block));
  }
}
